import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateMatchSetting extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/CreateMatchSettings");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateMatchSetting extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/UpdateMatchSettings");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllMatchSettings extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/GetAllMatchSettings");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllMatches extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/GetAllMatches");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateAMatch extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/CreateMatchBySettingId");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class AddUserToMatch extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/AddUserToMatchBy");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMatchDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/GetMatchBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class RemoveQuestionFromMatch extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/RemoveQuestionFromMatchByMatchId");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class AddQuestionsToMatch extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/AddQuestionsToMatchByMatchId");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllMatchQuestionPackages extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/GetAllMatchQuestionPackage");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateNewMatchQuestionPackage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/CreateMatchQuestionPackage");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateMatchQuestionPackage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/UpdateMatchQuestionPackage");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAMatchQuestionPackage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Matches/DeleteMatchQuestionPackageById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateMatchSetting,
  UpdateMatchSetting,
  GetAllMatchSettings,
  GetAllMatches,
  CreateAMatch,
  AddUserToMatch,
  GetMatchDetails,
  RemoveQuestionFromMatch,
  AddQuestionsToMatch,
  GetAllMatchQuestionPackages,
  CreateNewMatchQuestionPackage,
  UpdateMatchQuestionPackage,
  DeleteAMatchQuestionPackage,
};
